import { Box, Group } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { RemoteSourceRow } from 'components/tables/data/remote-source/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the user name.
 */
export default function UserColumn({ data: { user } }: { data: RemoteSourceRow }) {
  if (!user) {
    return null;
  }

  return (
    <Group spacing={8} noWrap align="center">
      <Box w={24} h={24}>
        <IconUser stroke={1.5} height={24} width={24} />
      </Box>
      <P2Regular color="gray.8">{user.fullName}</P2Regular>
    </Group>
  );
}
